import Page from "../Common/Page";
import React, { ReactNode } from "react";
import { Table, Form, Button, Row, Col } from "antd";
import { FileTextOutlined } from "@ant-design/icons";
import { JudgmentUnitSelecter } from "../Components/JudgmentUnitSelecter";
import { CommonMasterSelect } from "../Components/CommonMasterSelect";
import { ApplyDocumentDrawer } from "../Components/ApplyDocumentDrawer";
import { http } from "../Common/http";
import { AuthContext } from "../Auth/Auth";
import { Link } from "react-router-dom";
import withRouterDom from "../Common/WithReactRouterDom";
import { AbsenceTag } from "../Common/Icons";
import { localeCompare } from "../Common/Utils";

interface SearchResultBean {
  searchResult: [];
  examinationSubjectNames: any[];
}
interface StateType {
  documentDrawerVisible: boolean;
  defaultFy: string;
  judgmentUnit: string;
  columns: any[];
  datas: any[];
  applyDocuments: any[] | undefined;
  pageSize: number;
}
class PreparatoryStudentList extends React.Component<any, StateType> {
  static contextType = AuthContext;
  private _page: React.RefObject<Page>;
  private _form: React.RefObject<any>;

  constructor(props: any, context) {
    super(props, context);
    this._page = React.createRef<Page>();
    this._form = React.createRef();

    const { location } = this.props;
    this.state = {
      documentDrawerVisible: false,
      defaultFy: location.state?.fy
        ? location.state?.fy
        : context.user.currentYear.toString(),
      judgmentUnit: location.state?.judgmentUnit
        ? location.state?.judgmentUnit
        : "",
      columns: [],
      datas: [],
      applyDocuments: [],
      pageSize: 100,
    };
    // console.log(this.state.judgmentUnit);
  }
  componentDidMount() {
    const { location } = this.props;
    if (location.state) {
      this.onFinish({ judgmentUnit: location.state.judgmentUnit });
    }
  }

  // onChange = (pagination: any, filters: any, sorter: any, extra: any) => {
  //   console.log("params", pagination, filters, sorter, extra);
  // };
  defaultColumns = [
    {
      title: <div className="table-title">受験番号</div>,
      dataIndex: "examNo",
      key: "examNo",
      width: "10%",
      // filters: [
      //   {
      //     text: <span>2021000100001</span>,
      //     value: "2021000100001",
      //   },
      // ],
      // onFilter: (value, record) =>
      //   record.examNo.indexOf(value) === 0,
      sorter: (a: any, b: any) => a.examNo.localeCompare(b.examNo),
    },
    {
      title: <div className="table-title">氏名</div>,
      key: "name",
      width: "10%",
      // onFilter: (value, record) => record.name.indexOf(value) === 0,
      sorter: (a: any, b: any) =>
        `${a.sei} ${a.mei}`.localeCompare(`${b.sei} ${b.mei}`),
      render: (value: any, item: any, index: number) =>
        `${item.sei} ${item.mei}`,
    },
    {
      title: <div className="table-title">氏名カナ</div>,
      key: "kana",
      width: "12%",
      // onFilter: (value, record) => record.name.indexOf(value) === 0,
      sorter: (a: any, b: any) =>
        `${a.seiKana} ${a.meiKana}`.localeCompare(`${b.seiKana} ${b.meiKana}`),
      render: (value: any, item: any, index: number) =>
        `${item.seiKana} ${item.meiKana}`,
    },
    {
      title: <div className="table-title">高等学校名</div>,
      dataIndex: "highSchoolName",
      key: "highSchoolName",
      width: "12%",
      // onFilter: (value, record) => record.name.indexOf(value) === 0,
      sorter: (a: any, b: any) =>
        localeCompare(a.highSchoolName, b.highSchoolName),
    },
    {
      title: <div className="table-title">合計</div>,
      key: "sum",
      className: "score-column",
      sorter: (a: any, b: any) => {
        let sumScoreA = 0;
        if (a.scoreList) {
          a.scoreList.forEach((element) => {
            if (element.absenceFlag === "0") sumScoreA += element.totalScore;
          });
        }
        let sumScoreB = 0;
        if (b.scoreList) {
          b.scoreList.forEach((element) => {
            if (element.absenceFlag === "0") sumScoreB += element.totalScore;
          });
        }
        return sumScoreA - sumScoreB;
      },
      render: (value: any, item: any, index: number) => {
        let sumScore = 0;
        if (item.scoreList) {
          item.scoreList.forEach((element) => {
            if (element.absenceFlag === "0") sumScore += element.totalScore;
          });
        }
        return sumScore;
      },
    },
    {
      title: <div className="table-title">合否</div>,
      key: "passFailureResult",
      dataIndex: "passFailureResult",
      sorter: (a: any, b: any) =>
        localeCompare(a.passFailureResult, b.passFailureResult),
    },
    {
      title: "",
      key: "action",
      render: (value: any, item: any, index: number) => {
        if (item.applyDocuments && item.applyDocuments.length > 0) {
          return (
            <Link
              onClick={() => {
                this.onDocumentLinkClick(item.applyDocuments);
              }}
              to={""}
            >
              <FileTextOutlined />
              提出書類
            </Link>
          );
        } else {
          return "";
        }
      },
    },
  ];

  onFinish = async (values: any) => {
    // console.log("search:", values);
    try {
      this._page.current?.setState({ isPageLoading: true });
      const searchData = {
        Fy: this.state.defaultFy,
        JudgementUnitId: values.judgmentUnit ? values.judgmentUnit : null,
      };
      const result = await http<
        SearchResultBean,
        { Fy: string; JudgementUnitId: string }
      >({
        path: "/Applicant/search",
        method: "post",
        body: searchData,
        accessToken: this.context.accessToken,
      });
      if (result.ok && result.body) {
        const scoreCloumns: any[] = [];

        if (result.body.examinationSubjectNames) {
          result.body.examinationSubjectNames.forEach(
            (scoreColumn, esIndex) => {
              scoreCloumns.push({
                title: (
                  <div className="table-title">{scoreColumn.subjectName}</div>
                ),
                key: `Score${esIndex}`,
                sorter: (a: any, b: any) => {
                  let scoreA = 0;
                  let scoreB = 0;
                  let absA = "0";
                  let absB = "0";
                  if (a.scoreList && a.scoreList.length > 0) {
                    const filterArrayA = a.scoreList.filter(
                      (element, filterIndex, array) =>
                        element.examinationSubjectId ===
                        scoreColumn.examinationSubjectId
                    );
                    if (filterArrayA.length > 0) {
                      scoreA = filterArrayA[0].totalScore;
                      absA = filterArrayA[0].absenceFlag;
                    }
                  }
                  if (b.scoreList && b.scoreList.length > 0) {
                    const filterArrayB = b.scoreList.filter(
                      (element, filterIndex, array) =>
                        element.examinationSubjectId ===
                        scoreColumn.examinationSubjectId
                    );
                    if (filterArrayB.length > 0) {
                      scoreB = filterArrayB[0].totalScore;
                      absB = filterArrayB[0].absenceFlag;
                    }
                  }
                  if (absA !== absB) return absB.localeCompare(absA);
                  else return scoreA - scoreB;
                },
                render: (value: any, item: any, index: number) => {
                  if (item.scoreList && item.scoreList.length > 0) {
                    const filterArray = item.scoreList.filter(
                      (element, filterIndex, array) =>
                        element.examinationSubjectId ===
                        scoreColumn.examinationSubjectId
                    );
                    if (filterArray.length > 0) {
                      const score =
                        filterArray[0].absenceFlag === "1"
                          ? AbsenceTag
                          : filterArray[0].totalScore;
                      if (
                        scoreColumn.scoringFlag === "1" &&
                        this.context.user.browsePastFlag === "1"
                      ) {
                        const pid = filterArray[0].groupNo
                          ? filterArray[0].groupNo
                          : filterArray[0].applicantId;
                        return (
                          <Link
                            to={`/ScoringResultView/${filterArray[0].examinationSubjectId}/${pid}`}
                            state={{
                              fy: this.state.defaultFy,
                              judgmentUnit: this.state.judgmentUnit,
                            }}
                          >
                            {score}
                          </Link>
                        );
                      } else {
                        return score;
                      }
                    }
                  }
                  return "";
                },
              });
            }
          );
        }
        const updatedCloumns = [
          ...this.defaultColumns.slice(0, 4),
          ...scoreCloumns,
          ...this.defaultColumns.slice(4),
        ];
        this.setState({
          datas: result.body.searchResult,
          columns: updatedCloumns,
        });
      }
      this._page.current?.setState({ isPageLoading: false });
    } catch (error) {
      console.log(error);
      this._page.current?.setState({ isPageLoading: false });
    }
  };

  onJudgmentUnitSelected = async (record: any) => {
    // console.log("Success:", record);
    if (record) {
      this.setState({ judgmentUnit: record.fyJudgementUnitId });
    } else {
      this.setState({ judgmentUnit: "" });
    }
    this._form.current.submit();
  };

  onDocumentLinkClick = (appliDocuments: []) => {
    this.setState({
      documentDrawerVisible: true,
      applyDocuments: appliDocuments,
    });
  };
  onDocumentDrawerClose = () => {
    this.setState({
      applyDocuments: undefined,
      documentDrawerVisible: false,
    });
  };
  onFyChange = (newValue) => {
    this.setState({
      defaultFy: newValue.value,
      columns: [],
      datas: [],
    });
  };
  onShowSizeChange = (current, pageSize) => {
    this.setState({
      pageSize: pageSize,
    });
  };

  render(): React.ReactNode {
    const showTotal = (total: number, range: [number, number]): ReactNode => {
      return (
        <ul className="resultCount">
          <li className="grey">
            対象<span>{total}</span>
          </li>
        </ul>
      );
    };

    return (
      <Page ref={this._page} title="志願者一覧">
        <div className="data_content">
          <Form
            colon={false}
            ref={this._form}
            className="search_form"
            name="searchForm"
            onFinish={this.onFinish}
            layout="horizontal"
            labelAlign="left"
            initialValues={{
              fy: { value: this.state.defaultFy },
              judgmentUnit: this.state.judgmentUnit,
            }}
          >
            <Row>
              <Col span={6}>
                <Form.Item
                  label="入試年度"
                  name="fy"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <CommonMasterSelect
                    allowClear={false}
                    masterType={31}
                    onChange={this.onFyChange}
                    ucode="1"
                  />
                </Form.Item>
              </Col>
              <Col span={14}>
                <Form.Item
                  label="判定単位"
                  name="judgmentUnit"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <JudgmentUnitSelecter
                    width={500}
                    defaultFy={this.state.defaultFy}
                    onDataSelect={this.onJudgmentUnitSelected}
                  />
                </Form.Item>
              </Col>
              <Col span={4}>
                <Form.Item>
                  <Button type="primary" htmlType="submit">
                    表示
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <Table
            bordered
            rowKey={(record: any) => record.examNo}
            showSorterTooltip={false}
            columns={this.state.columns}
            dataSource={this.state.datas}
            scroll={{ y: "calc(100vh - 300px)" }}
            // onChange={this.onChange}
            pagination={{
              position: ["topLeft"],
              size: "small",
              showSizeChanger: true,
              onShowSizeChange: this.onShowSizeChange,
              pageSize: this.state.pageSize,
              pageSizeOptions: [100, 200],
              showTotal,
            }}
          />
          <ApplyDocumentDrawer
            documents={this.state.applyDocuments}
            onClose={this.onDocumentDrawerClose}
            visible={this.state.documentDrawerVisible}
          />
        </div>
      </Page>
    );
  }
}

export default withRouterDom(PreparatoryStudentList);
